var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-sayt.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/core-sayt.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("searchUrl")) {
var t_4 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_4);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "source") == "category") {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"category")),"searchSuggestions");
frame.set("searchSuggestions", t_5, true);
if(frame.topLevel) {
context.setVariable("searchSuggestions", t_5);
}
if(frame.topLevel) {
context.addExport("searchSuggestions", t_5);
}
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"category")),"showNoResultsMessage");
frame.set("showNoResultsMessage", t_6, true);
if(frame.topLevel) {
context.setVariable("showNoResultsMessage", t_6);
}
if(frame.topLevel) {
context.addExport("showNoResultsMessage", t_6);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "source") == "header") {
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"header")),"searchSuggestions");
frame.set("searchSuggestions", t_7, true);
if(frame.topLevel) {
context.setVariable("searchSuggestions", t_7);
}
if(frame.topLevel) {
context.addExport("searchSuggestions", t_7);
}
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"header")),"showNoResultsMessage");
frame.set("showNoResultsMessage", t_8, true);
if(frame.topLevel) {
context.setVariable("showNoResultsMessage", t_8);
}
if(frame.topLevel) {
context.addExport("showNoResultsMessage", t_8);
}
;
}
;
}
output += "<div class=\"c-search-suggestion js-site-search-sayt\">\n\n    ";
output += "\n    ";
output += "\n\n    <ul class=\"c-search-suggestion__ul js-site-search-sayt__ul ";
output += runtime.suppressValue((env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "searchSuggestions")) > 0?" c-search-suggestion__ul--border":""), env.opts.autoescape);
output += "\">\n\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "searchSuggestions")) > 0) {
output += "\n\n            ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "searchSuggestions");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("suggestion", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n\n                <li class=\"c-search-suggestion__li js-site-search-sayt__li\">\n\n                    <a class=\"c-search-suggestion__a js-search-suggestion\"\n                        href=\"";
output += runtime.suppressValue((lineno = 26, colno = 40, runtime.callWrap(t_4, "searchUrl", context, ["q=" + "" + env.getFilter("replace").call(context, env.getFilter("urlencode").call(context, t_12),"%20","+")])), env.opts.autoescape);
output += "&sayt=true\"\n                        data-suggestion-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\"\n                        data-suggestion-type=\"sayt\" ";
output += "\n                        data-qa-suggestion=\"";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "\">\n\n                        ";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "\n\n                    </a>\n\n                    ";
output += "\n                    ";
output += "\n\n                </li>\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "showNoResultsMessage")) {
output += "\n\n            <li class=\"c-search-suggestion__no-result\" data-qa-suggestion=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "suggestion"), env.opts.autoescape);
output += "\">\n\n                ";
output += runtime.suppressValue((lineno = 47, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["sayt_no_suggestions"])), env.opts.autoescape);
output += "\n\n            </li>\n\n        ";
;
}
;
}
output += "\n\n    </ul>\n\n    ";
output += "\n    ";
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-sayt.j2"] , dependencies)